// Autor: Miguel Angel Velazquez Valentin
export class JwtTokenAccountModel {
    name: string;
    businessCode: string;
    theme: string;

    static fromJson(json: string): JwtTokenAccountModel {
        const obj = JSON.parse(json);
        const result = new JwtTokenAccountModel();
        result.name = obj.name;
        result.businessCode = obj.businessCode;
        result.theme = obj.theme;
        return result;
    }
}
